import React, { Component } from 'react';
import { connect } from 'react-redux';

class Login extends Component {
  constructor (props) {
    super(props);

    this.state = {
      view: 'signin',
      isAnimatingsignin: false,
      isAnimatingsignup: false,
      'isAnimatingforget-password': false,
      username: '',
      password: ''
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.redirect) {
      this.props.history.push(this.props.redirect);
      this.props.clearRedirect();
    }
  }

  changeView (newView) {
    let newState = {};
    newState.view = newView;
    newState['isAnimating' + newView] = true;
    this.setState(newState);
  }

  validateForm () {
    return this.state.username.length > 0 && this.state.password.length > 0;
  }

  handleChange (event) {
    let newState = {};
    newState[event.target.attributes.name.value] = event.target.value;
    this.setState(newState);
  }

  async handleSubmitSignin (event) {
    event.preventDefault();

    const {
      username,
      password
    } = this.state;

    if (username && password) {
      this.props.loginUser(username, password);
    }
  }

  async handleSubmitSignup (event) {
    event.preventDefault();
  }

  async handleSubmitForgetPassword (event) {
    event.preventDefault();
    this.props.forgotPassword(this.state['forgot-password-email']);
  }

  render () {
    return (
      <div className='m-grid m-grid--hor m-grid--root m-page'>
        <div className={
          'm-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--2 m-login-2--skin-2 ' +
          (this.state.view === 'signin' ? 'm-login--signin' : '') +
          (this.state.view === 'signup' ? 'm-login--signup' : '') +
          (this.state.view === 'forget-password' ? 'm-login--forget-password' : '')
        } id='m_login'>
          <div className='m-grid__item m-grid__item--fluid m-login__wrapper'>
            <div className='m-login__container'>
              <div className='m-login__logo'>
                <img src='/assets/demo/default/media/img/logo/logo.png' alt='Kangarootime' />
              </div>
              <div className={
                'm-login__signin ' +
                (this.state.isAnimatingsignin ? 'flipInX animated' : '')
              }>
                <div className='m-login__head'>
                  <h3 className='m-login__title'>Sign In</h3>
                  <div className='m-login__desc'>{ this.props.errorMessage }</div>
                </div>
                <form className='m-login__form m-form' action='' onSubmit={(e) => this.handleSubmitSignin(e)}>
                  <div className='form-group m-form__group'>
                    <input
                      className='form-control m-input'
                      type='email'
                      autoCapitalize='off'
                      placeholder='Email'
                      name='username'
                      autoComplete='off'
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className='form-group m-form__group'>
                    <input
                      className='form-control m-input m-login__form-input--last'
                      type='password'
                      placeholder='Password'
                      name='password'
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className='row m-login__form-sub'>
                    <div className='col m--align-right m-login__form-right'>
                      <button id='m_login_forget_password' type={'button'} className='m-link' onClick={() => this.changeView('forget-password')}>Forget Password ?</button>
                    </div>
                  </div>
                  <div className='m-login__form-action'>
                    <button id='m_login_signin_submit'
                      type={'submit'}
                      tabIndex={-1}
                      className={
                        'btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-login__btn--primary' +
                      (this.props.isLoading ? ' m-loader m-loader--right m-loader--light' : '')
                      }
                    >Sign In</button>
                  </div>
                </form>
              </div>
              <div className={
                'm-login__signup ' +
                (this.state.isAnimatingsignup ? 'flipInX animated' : '')
              }>
                <div className='m-login__head'>
                  <h3 className='m-login__title'>Sign Up</h3>
                  <div className='m-login__desc'>Enter your details to create your account:</div>
                </div>
                <form className='m-login__form m-form' action='' onSubmit={(e) => this.handleSubmitSignup(e)}>
                  <div className='form-group m-form__group'>
                    <input className='form-control m-input' type='text' placeholder='Fullname' name='fullname' />
                  </div>
                  <div className='form-group m-form__group'>
                    <input className='form-control m-input' type='text' placeholder='Email' name='email' autoComplete='off' />
                  </div>
                  <div className='form-group m-form__group'>
                    <input className='form-control m-input' type='password' placeholder='Password' name='password' />
                  </div>
                  <div className='form-group m-form__group'>
                    <input className='form-control m-input m-login__form-input--last' type='password' placeholder='Confirm Password' name='rpassword' />
                  </div>
                  <div className='row form-group m-form__group m-login__form-sub'>
                    <div className='col m--align-left'>
                      <label className='m-checkbox m-checkbox--focus'>
                        <input type='checkbox' name='agree' />I Agree the <button className='m-link m-link--focus'>terms and conditions</button>.
                        <span />
                      </label>
                      <span className='m-form__help' />
                    </div>
                  </div>
                  <div className='m-login__form-action'>
                    <button id='m_login_signup_submit' className={
                      'btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn ' +
                      (this.props.isLoading ? ' m-loader m-loader--right m-loader--light' : '')
                    }>Sign Up</button>&nbsp;&nbsp;
                    <button id='m_login_signup_cancel' className='btn btn-outline-focus m-btn m-btn--pill m-btn--custom  m-login__btn' onClick={() => this.changeView('signin')}>Cancel</button>
                  </div>
                </form>
              </div>
              <div className={
                'm-login__forget-password ' +
                (this.state['isAnimatingforget-password'] ? 'flipInX animated' : '')
              }>
                <div className='m-login__head'>
                  <h3 className='m-login__title'>Forgotten Password?</h3>
                  <div className='m-login__desc'>Enter your email to reset your password:</div>
                </div>
                <form className='m-login__form m-form' action='' onSubmit={(e) => this.handleSubmitForgetPassword(e)}>
                  <div className='form-group m-form__group'>
                    <input className='form-control m-input' type='text' placeholder='Email' name='forgot-password-email' id='m_email' autoComplete='off' onChange={(e) => this.handleChange(e)} />
                  </div>
                  <div className='m-login__form-action'>
                    <button id='m_login_forget_password_submit' className={
                      'btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-login__btn--primary' +
                        (this.props.isLoading ? ' m-loader m-loader--right m-loader--light' : '')
                    }>Request</button>&nbsp;&nbsp;
                    <button id='m_login_forget_password_cancel' className='btn btn-outline-focus m-btn m-btn--pill m-btn--custom m-login__btn' onClick={() => this.changeView('signin')}>Cancel</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

function mapStateToProps (state) {
  return {
    userIsAuthenticated: state.authentication.loggedIn,
    isLoading: state.authentication.submitting,
    errorMessage: state.authentication.errorMessage,
    redirect: state.authentication.redirect
  };
}

function mapDispatchToProps (dispatch) {
  return {
    clearRedirect: (email) => dispatch({
      type: 'CLEAR_REDIRECT'
    }),
    loginUser: (username, password, rememberMe) => dispatch({
      type: 'LOGIN_REQUEST',
      userPayload: {
        username: username,
        password: password
      }
    }),
    forgotPassword: (email) => dispatch({
      type: 'FORGOT_PASSWORD_REQUEST',
      userPayload: {
        email: email
      }
    })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
